import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import IntlMessages from '../../util/IntlMessages';
import { connect } from 'react-redux';
import { getNavMenuItems } from './navMenuItems';

function navItemText(item) {
    if (item.intlId) {
        return <IntlMessages id={item.intlId} />;
    }
    return item.label;
}

class Menu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
        }
    }

    componentDidMount() {
        this.bindActiveHandlers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location || prevProps.showMenu !== this.props.showMenu) {
            this.bindActiveHandlers();
        }
    }

    bindActiveHandlers() {
        const { history } = this.props;
        const pathname = `#${history.location.pathname}`;
        const root = this.menuRoot;
        if (!root) {
            return;
        }

        const mainMenu = root.getElementsByClassName('nav-item');
        for (let i = 0; i < mainMenu.length; i++) {
            mainMenu[i].onclick = function () {
                for (let j = 0; j < mainMenu.length; j++) {
                    if (mainMenu[j].classList.contains('active')) {
                        mainMenu[j].classList.remove('active')
                    }
                }
                this.classList.toggle('active');
            }
        }
        const subMenuLi = root.getElementsByClassName('nav-arrow');
        for (let i = 0; i < subMenuLi.length; i++) {
            subMenuLi[i].onclick = function () {
                for (let j = 0; j < subMenuLi.length; j++) {
                    if (subMenuLi[j].classList.contains('active')) {
                        subMenuLi[j].classList.remove('active')
                    }
                }
                this.classList.toggle('active');
            }
        }
        const activeLi = root.querySelector('a[href="' + pathname + '"]');
        try {
            const activeNav = this.closest(activeLi, 'ul');
            if (activeNav.classList.contains('sub-menu')) {
                this.closest(activeNav, 'li').classList.add('active');
            } else {
                this.closest(activeLi, 'li').classList.add('active');
            }
            const parentNav = this.closest(activeNav, '.nav-item');
            if (parentNav) {
                parentNav.classList.add('active');
            }

        } catch (e) {

        }
    }

    closest(el, selector) {
        try {
            let matchesFn;
            ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
                if (typeof document.body[fn] == 'function') {
                    matchesFn = fn;
                    return true;
                }
                return false;
            });

            let parent;

            while (el) {
                parent = el.parentElement;
                if (parent && parent[matchesFn](selector)) {
                    return parent;
                }
                el = parent;
            }
        } catch (e) {

        }

        return null;
    }

    render() {
        let user = JSON.parse(localStorage.getItem('userData'));
        const items = getNavMenuItems(user);

        return (
            <div className="app-main-menu" ref={(el) => { this.menuRoot = el; }}>
                {items.length ? (
                    <ul className="navbar-nav navbar-nav-mega">
                        {items.map((item) => (
                            <li key={item.id} className="nav-item">
                                {item.to ? (
                                    <NavLink className="prepend-icon" to={item.to}>
                                        <span className="nav-text">{navItemText(item)}</span>
                                    </NavLink>
                                ) : (
                                    <a href="javascript:void(0)">{navItemText(item)}</a>
                                )}
                                {item.children && item.children.length ? (
                                    <ul className="sub-menu">
                                        {item.children.map((child) => (
                                            <li key={child.id}>
                                                <NavLink className="prepend-icon" to={child.to}>
                                                    <span className="nav-text">{navItemText(child)}</span>
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        showMenu: state.companyReducer.ShowMenu
    }
}

export default withRouter(connect(mapStateToProps)(Menu));
